import { useQuery } from "@tanstack/react-query";
import { ProjectQueriesTags } from "../../api/project";
import { getProjectImage } from "../api/get-project-image";

interface IUseProjectImage {
  projectId: string;
  imageId: string;
  enabled: boolean;
}

export function useProjectImage({
  projectId,
  imageId,
  enabled,
}: IUseProjectImage) {
  return useQuery({
    queryFn: () =>
      getProjectImage({
        fileId: imageId,
        type: "url",
      }),
    queryKey: ProjectQueriesTags.getProjectImage({
      projectId,
      fileId: imageId,
      type: "url",
    }),
    enabled,
  });
}
